import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';

import { localStorageCartId } from '../_common/constants';

import { Cart } from '../_models/cart';
import { AddCartItem } from '../_models/add-cart-item';
import { CartItemSummary } from '../_models/cart-item-summary';

@Injectable()
export class CartsService {
    private readonly apiController: string;
    private _cartCount = new Subject<number>();

    cartCount: Observable<number>;

    constructor(private readonly httpClient: HttpClient) {
        this.apiController = `${environment.webApiUrl}/api/v${environment.webApiVersion}/carts`;

        this._cartCount.next(0);
        this.cartCount = this._cartCount.asObservable();
    }

    addCartItem(cartUid: string, userId: number, eventPerformerExperienceId: number, quantity: number): Observable<Cart> {
        const httpHeaders = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});

        return this.httpClient.post<Cart>(`${this.apiController}/addCartItem?cartUid=${cartUid}&userId=${userId}&eventPerformerExperienceId=${eventPerformerExperienceId}&quantity=${quantity}`, {headers: httpHeaders})
            .map(
                (cart: Cart) => {
                    let cartModel = new Cart().deserialize(cart);
                    this.saveCartId(cart);
                    this._cartCount.next(cartModel.getTotalItemCount());
                    return cartModel;
                }
            );
      }

    addCartItems(cartUid: string, userId: number, addCartItems: AddCartItem[]): Observable<Cart> {
        const httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.httpClient.post<Cart>(`${this.apiController}/addCartItems?cartUid=${cartUid}&userId=${userId}`, addCartItems, {headers: httpHeaders})
            .map(
                (cart: Cart) => {
                    let cartModel = new Cart().deserialize(cart);
                    this.saveCartId(cart);
                    this._cartCount.next(cartModel.getTotalItemCount());
                    return cartModel;
                }
            );
      }

    addPromoCode(cartUid: string, userId: number, code: string): Observable<Cart> {
        const httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.httpClient.post<Cart>(`${this.apiController}/addPromoCode?cartUid=${cartUid}&userId=${userId}&code=${code}`, {headers: httpHeaders})
            .map(
                (cart: Cart) => {
                    let cartModel = new Cart().deserialize(cart);
                    this.saveCartId(cart);
                    this._cartCount.next(cartModel.getTotalItemCount());
                    return cartModel;
                }
            );
    }

    clear(cartUid: string): void {
        if (cartUid !== null) {
            this.httpClient.get(`${this.apiController}/clearCart?cartUid=${cartUid}`).subscribe(
                () => {
                    localStorage.removeItem(localStorageCartId);
                    this._cartCount.next(0);
                }
            );
        }
    }

    get(cartUid: string, userId: number): Observable<Cart> {
        return this.httpClient.get<Cart>(`${this.apiController}/getCart?cartUid=${cartUid}&userId=${userId}`)
            .map(
                (cart: Cart) => {
                    let cartModel = new Cart().deserialize(cart);
                    this._cartCount.next(cartModel.getTotalItemCount());
                    return cartModel;
                }
            );
    }

    removeCart(): void {
        localStorage.removeItem(localStorageCartId);
        this._cartCount.next(0);
    }

    removeCartItem(cartUid: string, eventPerformerExperienceId: number): Observable<Cart> {
        const httpHeaders = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});

        return this.httpClient.post<Cart>(`${this.apiController}/removeCartItem?cartUid=${cartUid}&eventPerformerExperienceId=${eventPerformerExperienceId}`, {headers: httpHeaders})
            .map(
                (cart: Cart) => {
                    let cartModel = new Cart().deserialize(cart);
                    this.saveCartId(cart);
                    this._cartCount.next(cartModel.getTotalItemCount());
                    return cartModel;
                }
            );
    }

    removePromoCode(cartUid: string, userId: number): Observable<Cart> {
        const httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.httpClient.post<Cart>(`${this.apiController}/removePromoCode?cartUid=${cartUid}&userId=${userId}`, {headers: httpHeaders})
            .map(
                (cart: Cart) => {
                    let cartModel = new Cart().deserialize(cart);
                    this.saveCartId(cart);
                    this._cartCount.next(cartModel.getTotalItemCount());
                    return cartModel;
                }
            );
    }

    updateCartItem(cartUid: string, eventPerformerExperienceId: number, quantity: number): Observable<Cart> {
        const httpHeaders = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});

        return this.httpClient.post<Cart>(`${this.apiController}/updateCartItem?cartUid=${cartUid}&eventPerformerExperienceId=${eventPerformerExperienceId}&quantity=${quantity}`, {headers: httpHeaders})
            .map(
                (cart: Cart) => {
                    let cartModel = new Cart().deserialize(cart);
                    this.saveCartId(cart);
                    this._cartCount.next(cartModel.getTotalItemCount());
                    return cartModel;
                }
            );
    }

    private saveCartId(cart: Cart): void {
        localStorage.setItem(localStorageCartId, cart.cartUid);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/carts.service.ts